<template>
  <div class="col-auto">
    <label class="col-form-label mr-2"> {{ label }} </label>
    <b-form-select class="custom-select custom-select-sm" style="width: max-content;"
      :options="opt"
      :value="value"
      @change="changeItem">
    </b-form-select>
  </div>
</template>

<script>
export default {
  props: {
    opt: {},
    value:{},
    label: ""
  },
  setup(props, context) {
    const opt = props.opt;
    const value = props.value;

    return {
      ...actions(props.data, context)
    }
  },
  computed: {
    computedModel() {
      return this.value;
    }
  }
}
function actions(data, context) {
  function changeItem(val) {
    context.emit('changeItem', val)
  }
  return {changeItem};
}
</script>
